import HomePage from "../pages/General/HomePage.js";
import Login from "../pages/Accounts/Login";
import ForgotPassword from "../pages/Accounts/ForgotPassword";
import ResetPassword from "../pages/Accounts/ResetPassword";
import ChangePassword from "../pages/Accounts/ChangePassword.js";
import ApplicationMainPage from "../pages/Application/AdmissionInformation.js";
import ApplicationFormDetailNew from "../pages/Application/ApplicationFormDetailNew.js";
import ApplicationFormDetailExisting from "../pages/Application/ApplicationFormDetailExisting.js";
import ApplicationEnquiryNewParent from "../pages/Application/ApplicationEnquiryNewParent.js";


export const PublicRoutes = [
  { path: "/", element: <HomePage /> },
  { path: "/homepage", element: <HomePage /> },
  { path: "/index", element: <HomePage /> },
  { path: "/login", element: <Login /> },
  { path: "change-password", element: <ChangePassword /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "new-applicant-list", element: <ApplicationMainPage /> },
  { path: "newapplicantform", element: <ApplicationFormDetailNew /> },
  { path: "existingapplicantform", element: <ApplicationFormDetailExisting /> },
  {
    path: "application-enquiry-newparent",
    element: <ApplicationEnquiryNewParent />,
  },
];
